export const ChevronLeftIcon = () => (
  <path
    d="M15.5996 18.957L9.59961 12.957L15.5996 6.95703"
    stroke="#8F918D"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
  />
);
